<template lang="">
    <div class="horizontal-menu-wrapper pt-15">
      <b-navbar
        type="light"
        class="header-navbar navbar-shadow align-items-center navbar-fixed p-1 justify-content-center navbar-subNav"
      >
        <b-navbar-nav class="justify-content-center">
          <b-nav-item
            to="/channel-sms"
            :class="`${currentRouteName === 'channel-sms' ? 'active' : ''}`"
          >
            <span class="font-weight-bolder">
              SMS Broadcast
            </span>
          </b-nav-item>
          <!-- <b-nav-item
            to="/channel-ussd"
            :class="`${currentRouteName === 'ussd-747' ? 'active' : ''}`"
          >
            <span class="font-weight-bolder">
              USSD 747
            </span>
          </b-nav-item> -->
          <b-nav-item
            to="/channel-flash"
            :class="`${currentRouteName === 'flash-message' ? 'active' : ''}`"
          >
            <span class="font-weight-bolder">
              Flash Message
            </span>
          </b-nav-item>
          <!-- <b-nav-item 
            to="/channel-digiads"
            :class="`${currentRouteName === 'channel-digiads' ? 'active' : ''}`"
          >
            <span class="font-weight-bolder">
              Digital Ads Banner
            </span>
          </b-nav-item>
          <b-nav-item 
            to="/channel-bima+"
            :class="`${currentRouteName === 'channel-bima+' ? 'active' : ''}`"
          >
            <span class="font-weight-bolder">
              bima+
            </span>
          </b-nav-item> -->
        </b-navbar-nav>
      </b-navbar>
    </div>
</template>
<script>
import {
  // BRow,
  // BCol,
  BNavItem,
  BNavbar,
  BNavbarNav,
} from 'bootstrap-vue'

export default {
  components: {
    // BRow,
    // BCol,
    BNavbar,
    BNavbarNav,
    BNavItem,
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
  },
}
</script>
<style lang="scss">
.navbar-subNav {
  ul {
    position: absolute;
    left: 15%;
    li {
        margin: 6px 7px;
        &:nth-child(1) {
            margin-left: 0;
        }
    }
    a {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    .active::after {
        content: "";
        width: 100%;
        height: 2px;
        display: block;
        position: relative;
        bottom: -14px;
        background: #4B6AAE;
    }
  }
  @media only screen and (max-width: 830px) {
    ul {
      position: static;
    }
  }
}
</style>